import CategoryList from './CategoryList'
// Set featured variable arrays that match data set

// Make array of categorys
const CategoryListArr = Object.values(CategoryList).map(obj => Object.keys(obj))

/* Util to create a new object by filtering an array of keys from data(objArr) to match an array(arr) */
const featureObjectCrea = (obj, objArr, arr) => {
    const newObj = objArr.filter(key => arr.includes(key)).reduce((acc, curr) => {
        acc[curr] = obj[curr]
        return acc
    }, {})

    return newObj
}

const charWithCategories = {
    character: '',
    featureImportant: {},
    featureSwitch: {},
    featureScale: {},
    featureHand: {},
    featureCoin: {},
    featureWhisper: {},
    featureCommander: {},
    featureGrandM: {},
}

const newKeysArray = Object.keys(charWithCategories).filter(e => e !== 'character')

/* Creates a new data that adds children objects for different features used in Ranker */
const transformedData = data => data.map(obj => {
    const innerObjArray = Object.keys(obj)

    const result = newKeysArray.reduce((newObject, curr, i) => {
        const newObj = featureObjectCrea(obj, innerObjArray, CategoryListArr[i])
        return { ...newObject, [curr]: newObj }
    }, { character: obj.character.toString() })

    return result
})

export { transformedData }



// WEBPACK FOOTER //
// ./src/utils/FilterData.js